<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-active="isModalFieldUsedDrawingsVisible" :vm-is-valid="!$v.form.$invalid" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12 v-if="isAdd")
        b-form-group
          vm-select(:label='$t("field_used_drawings.category")', v-model='form.category' :danger="$v.form.category.$invalid && $v.form.category.$model" :placeholder='$t("field_used_drawings.category_placeholder")')
            vm-select-item(:value='1', text='Structural steel framing')
            vm-select-item(:value='2', text='Joists')
            vm-select-item(:value='3', text='Decking')
            vm-select-item(:value='4', text='Miscellaneous')
      vm-col(vm-justify="center", vm-align="center", vm-w=12 v-if="isAdd")
        b-form-group
          vm-input(:placeholder='$t("field_used_drawings.drawing_number_placeholder")' :danger="$v.form.drawing_number.$invalid && $v.form.drawing_number.$model" :danger-text="$t('validation.required', { attribute: $t('field_used_drawings.drawing_number') })" v-model="form.drawing_number" :label='$t("field_used_drawings.drawing_number")')
      vm-col(vm-justify="center", vm-align="center", vm-w=12 v-if="isAdd")
        b-form-group
          vm-input(:placeholder='$t("field_used_drawings.title_placeholder")' :danger="$v.form.title.$invalid && $v.form.title.$model" :danger-text="$t('validation.required', { attribute: $t('field_used_drawings.title') })" v-model="form.title" :label='$t("field_used_drawings.title")')
      vm-col(vm-justify="center", vm-align="center", vm-w=12 v-if="isAdd")
        b-form-group
          vm-input(:placeholder='$t("field_used_drawings.revision_placeholder")' :danger="$v.form.revision.$invalid && $v.form.revision.$model" :danger-text="$t('validation.required', { attribute: $t('field_used_drawings.revision') })" v-model="form.revision" :label='$t("field_used_drawings.revision")')
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          input(type="file", ref="file", v-on:change="handleFileUpload()", accept="application/pdf")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-date-picker(style="width: 100%" :label='$t("field_used_drawings.date")' :danger="$v.form.date.$invalid && $v.form.date.$model" :danger-text="$t('validation.required', { attribute: $t('field_used_drawings.date') })" v-model="form.date")
</template>
<script>
import moment from 'moment'
import { required, requiredIf } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('InOrders')

export default {
  name: 'ModalFieldUsedDrawings',
  props: {
    form: {
      type: Object
    },
    index: {
      type: Number
    },
    isAdd: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    file: ''
  }),
  validations () {
    return {
      form: {
        category: {
          required
        },
        drawing_number: {
          required
        },
        title: {
          required
        },
        revision: {
          required
        },
        date: {
          required
        },
        file: {
          required: requiredIf(function () { return this.imageValidate })
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'isModalFieldUsedDrawingsVisible',
      'inOrder'
    ]),
    getTitle () {
      return this.isAdd ? this.$t('field_used_drawings.add') : this.$t('field_used_drawings.edit')
    },
    imageValidate () {
      return this.file.length < 1
    }
  },
  methods: {
    ...mapActions([
      'setModalFieldUsedDrawingsVisible',
      'addFieldUsedDrawing',
      'editFieldUsedDrawing'
    ]),
    handleFileUpload () {
      this.file = this.$refs.file.files[0]
    },
    async saveRecord () {
      this.form.date = moment(this.form.date).format('YYYY-MM-DD')
      this.isAdd ? await this.addFieldUsedDrawing({ form: this.form, project: this.inOrder, file: this.file }) : await this.editFieldUsedDrawing({ form: this.form, file: this.file })
      this.file = ''
    },
    close () {
      this.setModalFieldUsedDrawingsVisible(false)
    }
  }
}
</script>
